export const FURROW_LITE_REQUEST = "FURROW_LITE_REQUEST";
export const FURROW_LITE_SUCCESS = "FURROW_LITE_SUCCESS";
export const FURROW_LITE_FAILED = "FURROW_LITE_FAILED";
